import React from 'react';
import Frontpage from '../components/Reports/Frontpage';

const Reports = () => {
  return <Frontpage />;
};

export default Reports;
